import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {IMapOffer} from "../../../maps/types/IMapOffer";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

export const transformRecommendedPropertyIntoMapOffer = (offer: IRecommendedProperty): IMapOffer => ({
    id: offer.id,
    name: offer.offer.name,
    price: offer.price,
    coordinates: offer.offer.geo_point.coordinates,
    vendorName: offer.offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.offer.vendor.logo_url, 80, 60),
    description: `${offer.rooms} ${roomsPluralize(offer.rooms)}, ${areaFormat(offer.area)}`,
    mainImage: {
        desktop: getThumbnailLink(offer.offer.main_image_url, 224, 147),
        mobile: getThumbnailLink(offer.offer.main_image_url, 155, 87)
    },
    distance: offer.distance,
    region: {
        country: offer.region.country
    }
});

export const transformRecommendedOfferIntoMapOffer = (offer: IRecommendedOffer): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60),
    description: "",
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 277, 160),
        mobile: getThumbnailLink(offer.main_image_url, 155, 87)
    },
    distance: offer.distance,
    region: {
        country: offer.region.country
    }
});
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {IMapOffer} from "../../../maps/types/IMapOffer";
import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";

const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

export const transformRecommendedPropertyIntoMapOffer = (offer: IRecommendedProperty): IMapOffer => ({
    id: offer.id,
    name: offer.offer.name,
    price: offer.price,
    coordinates: offer.offer.geo_point.coordinates,
    vendorName: offer.offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.offer.vendor.logo_url, 80, 60),
    description: `${offer.rooms} ${roomsPluralize(offer.rooms)}, ${areaFormat(offer.area)}`,
    mainImage: {
        desktop: getThumbnailLink(offer.offer.main_image_url, 224, 147),
        mobile: getThumbnailLink(offer.offer.main_image_url, 155, 87)
    },
    distance: offer.distance,
    region: {
        country: offer.region.country
    }
});

export const transformRecommendedOfferIntoMapOffer = (offer: IRecommendedOffer): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60),
    description: "",
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 277, 160),
        mobile: getThumbnailLink(offer.main_image_url, 155, 87)
    },
    distance: offer.distance,
    region: {
        country: offer.region.country
    }
});
